export const FloatTabs: Record<string, string> = {
  loanDetail: 'Loan Details',
  notification: 'Notification',
  underwriting: 'Underwriting',
  documents: 'Documents',
  notes: 'Notes',
  textMessages: 'Text Messages',
}

export const pageUrls: Record<string, any> = {
  loanActions: { title: 'Actions', url: '/loan_actions' },
  aiProject: { title: 'AI Project', url: '/loan_ai_project' },
  amortizationSchedule: { title: 'Amortization Schedule', url: '/configurablePage/amortization_schedule' },
  borrowingBase: { title: 'Borrowing Base', url: '/borrowingBase' },
  budget: { title: 'Budget & Scope of Work', url: '/configurablePage/budget' },
  closingCalendar: { title: 'Closing Calendar', url: '/configurablePage/closing_calendar' },
  closingScreen: { title: 'Closing Screen', url: '/configurablePage/closing_screen' },
  compliance: { title: 'Compliance', url: '/configurablePage/compliance' },
  contractorApplication: { title: 'Contractor Application', url: '/contractor_application' },
  dataverify: { title: 'DataVerify', url: '/configurablePage/underwriting', menu: 'dataVerify' },
  documentsGenie: { title: 'DocumentsGenie', url: '/configurablePage/documents_genie' },
  drawRequest: { title: 'Draw Request', url: '/drawRequest' },
  fci: { title: 'FCI', url: '/configurablePage/fci' },
  feeWorksheet: { title: 'Fee Worksheet', url: '/configurablePage/fee_worksheet' },
  funding: { title: 'Funding', url: '/configurablePage/funding' },
  hmda: { title: 'HMDA', url: '/hmda' },
  invoice: { title: 'Invoice', url: '/configurablePage/invoice' },
  loanApplication: { title: 'Loan Application', url: '/loan_process/application' },
  loanChangeRequest: { title: 'Loan Change Request', url: '/loan_change_request' },
  loanIntake: { title: 'Loan Intake', url: '/configurablePage/loan_intake' },
  loanOverview: { title: 'Loan Overview', url: '/loan_process/overview' },
  loanStructure: { title: 'Loan Structure', url: '/loan_process/structure' },
  loanSubmission: { title: 'Loan Submission', url: '/loan_process/submit' },
  notes: { title: 'Notes', url: '/configurablePage/notes' },
  orderValuation: { title: 'Order Valuation', url: '/configurablePage/order_valuation' },
  parties: { title: 'Parties', url: '/parties' },
  postClosing: { title: 'Post Closing', url: '/configurablePage/post_closing' },
  realEstateOwned: { title: 'Real Estate Owned', url: '/configurablePage/reo' },
  // Trailing slash so the global /reminders list is not treated as a loan page
  reminders: { title: 'Reminders', url: '/reminders/' },
  seconadryMarketing: { title: 'Secondary Marketing', url: '/configurablePage/secondary_marketing' },
  servicing: { title: 'Servicing', url: '/configurablePage/servicing' },
  creditDenial: { title: 'Statement of Credit Denial', url: '/creditDenial' },
  tasks: { title: 'Tasks', url: '/tasks/loan' },
  underwriting: { title: 'Underwriting', url: '/configurablePage/underwriting' },
}

/** Floater page keys sorted by display title (A→Z). */
export const sortedPageUrlKeys = Object.keys(pageUrls).sort((a, b) =>
  String(pageUrls[a].title).localeCompare(String(pageUrls[b].title), undefined, { sensitivity: 'base' }),
)

/** Extra path prefixes (legacy / alternate routes) used to resolve the current page for floater visibility. */
export const pageUrlAliases: Record<string, string[]> = {
  orderValuation: ['/order_valuation'],
  underwriting: ['/underwriting/'],
  servicing: ['/servicing/'],
  realEstateOwned: ['/reo/'],
  budget: ['/budget/'],
  dataverify: ['/underwriting/'],
  reminders: ['/reminders/'],
  aiProject: ['/loan_ai_project/'],
}

/** Resolve which floater pageUrls key the current location belongs to (most specific match wins). */
export const resolveFloaterPageKey = (pathname: string, menu: string | null = null): string | null => {
  let bestKey: string | null = null
  let bestScore = -1

  Object.keys(pageUrls).forEach((key) => {
    const cfg = pageUrls[key]
    const prefixes = [cfg.url, ...(pageUrlAliases[key] || [])].filter(Boolean)

    prefixes.forEach((prefix: string) => {
      if (!pathname.startsWith(prefix)) return
      // Avoid treating bare "/servicing-*" helpers as the loan Servicing page.
      if (key === 'servicing' && prefix === '/servicing/' && !/^\/servicing\/\d+/.test(pathname)) return
      if (cfg.menu) {
        if (!menu || !menu.includes(cfg.menu)) return
      } else if (key === 'underwriting' && menu?.includes('dataVerify')) {
        // Prefer the DataVerify entry when that menu is active on underwriting.
        return
      }

      const score = prefix.length + (cfg.menu ? 1000 : 0)
      if (score > bestScore) {
        bestScore = score
        bestKey = key
      }
    })
  })

  return bestKey
}
